

<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <h2>Adjust next maintenance date</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="'Close'" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>Choose a new date for the next scheduled maintenance. This will not change past visits.</h3>
    </div>
    

    <div class="flx-modal__body mp-body">
        <div class="mp-inline-row-box mp-row pb-3">
            <div class="mp-note-option me-1">Current next date: <b>{{ data.nextMaintenanceDateTime  | momentDate : data.dateFormat :  data.dateFormateChange  }}</b></div>
        </div>

       <label class="field-label">New next maintenance date</label>
         <div class="field-row field-row--auto mb-1">
             <div>
                  <p-calendar [yearNavigator]="true" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" [minDate]="tomorrow" [(ngModel)]="nextMaintenanceDateTime"  styleClass="cal-btn"></p-calendar>
             </div>
         </div>
        <p class="mp-hint fst-italic">Only future dates are allowed. Future work orders will be rescheduled to this date.</p>
    </div>

    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">Cancel</button>
        <p-button label="Save" (onClick)="updateNextMaintenanceDate()" [disabled]="isSubmitDisabled()" styleClass="h-32"></p-button>
    </div>
</div>